export default function HomeFooter(){
	const arrow = "<-/"
	return(
		<div id="arrow">
			<h2 className="link">{arrow} HOME</h2>
		</div>
	)
}